import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

function Cursor(props) {
    return (
        <Typography
            sx={{
                typography: {
                    xs: 'h5',
                    sm: 'h4',
                    md: 'h3'
                }
            }}
            component="span"
        >
            {props.cursor}
        </Typography>
    );
};

const Typewriter = ({ text, delay = 150, cursor = '|', onComplete }) => {
    const [displayText, setDisplayText] = useState("");
    const [displayCursor, setDisplayCursor] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        let cursorIntervalId;
        let intervalId;

        intervalId = setInterval(() => {
            setDisplayText((prevText) => prevText + text[currentIndex]);
            setCurrentIndex((prevIndex) => prevIndex + 1);
            if (currentIndex % 2 === 0) {
                setDisplayCursor((prevCursor) => !prevCursor);
            }
        }, delay);

        if (currentIndex === text.length) {
            clearInterval(intervalId);

            cursorIntervalId = setInterval(() => {
                setDisplayCursor((prevCursor) => !prevCursor);
            }, 600);

            if (onComplete) onComplete();
        }

        return () => { 
            clearInterval(intervalId);
            clearInterval(cursorIntervalId);
        }
    }, [currentIndex]);

    return (
        <Box>
            <Typography
                sx={{
                    typography: {
                        xs: 'coverAnimatedTextXS',
                        sm: 'h4',
                        md: 'h3'
                    }
                }}
                color="customText.white"
            >
                {displayText}
                {displayCursor && <Cursor cursor={cursor} />}
            </Typography>
        </Box>
    );
};

export default Typewriter;